import store from '@/store';
export default {
    height: "auto",
    calcHeight: 30,
    tip: false,
    searchShow: true,
    searchSpan: 5,
    searchMenuSpan: 4,
    searchLabelWidth: 120,
    border: true,
    index: true,
    viewBtn: false,
    editBtn: false,
    delBtn: false,
    addBtn: false,
    selection: false,
    dialogClickModal: false,
    column: [{
            label: "主键id",
            prop: "id",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            type: "input",
        },
        {
            label: "产品类型",
            prop: "rentType",
            type: "select",
            dicData: store.getters.porductTypes
        },
        {
            label: "产品类型",
            prop: "rentTypeList",
            type: "select",
            search: true,
            searchMultiple: true,
            hide: true,
            showColumn: false,
            dicData: store.getters.porductTypes
        },
        {
            label: "租赁人",
            prop: "name",
            type: "input",
            search: "true",
        },
        {
            label: "手机号",
            prop: "phoneNumber",
            type: "input",
        },
        {
            label: "放款总额",
            prop: "lendingAmount",
            type: "input",
        },
        {
            label: "未还租金(仅本金)",
            prop: "unpaidRentAmount",
            type: "input",
        },
        {
            label: "客户期数",
            prop: "currentTenancy",
            type: "input",
            formatter: (val, value, label) => {
              return value ? value + "/" + val["tenancy"] : "-";
            },
        },

        {
            label: "状态",
            prop: "status",
            type: "select",
            search: true,
            dicData: [{
                    label: "正常还款",
                    value: 1,
                },
                {
                    label: "代偿还款",
                    value: 2,
                },
                {
                    label: "逾期未还",
                    value: 3,
                },
            ],
        },
        {
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },

    ],
};
